import React from 'react';
import Lottie from 'lottie-react';
import greeniaLottieLoader from '../../assets/lottie/greenia-loading.json';

function LoadingAnimation() {
  return (
    <Lottie animationData={greeniaLottieLoader} loop />
  );
}

export default LoadingAnimation;
